// extracted by mini-css-extract-plugin
export var disabled = "_sc-0";